import { cardsData } from '@/mocks/home';

export default function SectionCards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg">
            <i className="ri-article-line text-primary-600 text-lg"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            深度爆料
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.map((card) => (
            <article
              key={card.id}
              className="bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-colors cursor-pointer group"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-secondary-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    const parent = target.parentElement;
                    if (parent) {
                      parent.style.display = 'none';
                    }
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
                  {card.category}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 mb-3 line-clamp-2 leading-relaxed">
                  {card.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{card.author}</span>
                  <div className="flex items-center gap-3">
                    <span>{card.time}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line text-[10px]"></i>
                      {card.reads}
                    </span>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}